import { DEFAULT_PROFILE_IMAGE_URL } from "@/constants/branding";
import {
  getOptimizedImageUrl,
  type ImageSizePreset,
} from "@/utils/imageOptimization";

/**
 * Utility function to get the appropriate cover URL for a track
 * Uses a multi-layer fallback system with the default profile image as the final fallback
 * Optionally optimizes the image for the specified size
 */
export function getTrackCoverUrl(
  coverUrl?: string,
  size?: ImageSizePreset,
): string {
  // Default profile image - this is our final fallback
  const defaultImage = DEFAULT_PROFILE_IMAGE_URL;

  // Return default image if no cover URL or if it's a placeholder
  if (
    !coverUrl ||
    coverUrl === "/placeholder.svg" ||
    coverUrl.includes("placeholder")
  ) {
    return defaultImage;
  }

  // If we have a cover URL, optionally optimize it
  if (size) {
    return getOptimizedImageUrl(coverUrl, size);
  }

  return coverUrl;
}

/**
 * Handle image loading errors by falling back to site favicon
 * This can be used in onError handlers for img elements
 */
export function handleImageError(
  event: React.SyntheticEvent<HTMLImageElement, Event>,
): void {
  const defaultImage = DEFAULT_PROFILE_IMAGE_URL;
  const target = event.currentTarget;

  // Prevent infinite loop if the fallback image also fails
  if (target.src !== defaultImage) {
    target.src = defaultImage;
  }
}
